

















import Vue from 'vue';
import TIcons from '../../types/TIcons';

interface ICheckboxComponent {
  icons: typeof TIcons;
  toggled: boolean;
}

export default Vue.extend({
  data(): ICheckboxComponent {
    return {
      icons: TIcons,
      toggled: false,
    };
  },
  computed: {
    showIcon(): string {
      return this.toggled ? this.icons.checkboxFull : this.icons.checkboxEmpty;
    },
  },
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    icon: {
      default: null,
      type: String,
    },
    initialState: {
      default: ``,
      type: String,
    },
    testSelector: {
      default: ``,
      type: String,
    },
    testSelectorIndex: {
      default: -1,
      type: Number,
    },
    toggledProp: {
      default: false,
      type: Boolean,
    },
  },
  mounted(): void {
    this.toggled = this.initialState === `clicked`;
  },
  methods: {
    clicked(): void {
      this.toggled = !this.toggled;
      this.$emit(`click`);
    },
  },
  watch: {
    toggledProp: {
      handler(): void { this.toggled = this.toggledProp; },
      immediate: true,
    },
  },
});
